module.exports = __webpack_public_path__ + "img/instagram_blue.41a14ed4.svg";